import Grid from "@mui/material/Grid";
import QuantityInput from "../../common/QuantityInput";
import {
  AutocompleteInput,
  maxLength,
  minLength,
  number,
  ReferenceInput,
  required,
} from "react-admin";
import CodeDetailInput from "../../common/CodeDetailInput";
import {
  inputTextProduct,
  matchSuggestionProduct,
  OptionRendererProduct,
} from "../../../common/OptionRendererProduct";
import ProductInput from "../../../purchaseOrders/common/ProductInput";
import { useFormContext } from "react-hook-form";
import { useRef } from "react";
import useEnterToAddRowAndFocus from "../../../../utils/useEnterToAddRowAndFocus";

const uniqueItem = (value, allValues, elm) => {
  if (!allValues.mutation_repacking_items) return undefined;
  let count = 0;
  for (let i = 0; i < allValues.mutation_repacking_items.length; i++) {
    const elm = allValues.mutation_repacking_items[i];
    if (value === elm.product_id) {
      if (count > 0) {
        return "Duplicate is not allowed";
      }
      count += 1;
    }
  }
  return undefined;
};

const validateCode = [required(), minLength(36), maxLength(36), uniqueItem];
const validateLocation = [required(), minLength(36), maxLength(36)];
const validateQuantity = [required(), number()];

const CstInput = ({
  code,
  quantity,
  formData,
  // NAMA-NAMA SOURCE
  idSource,
  quantitySource,
  nameSource,
  qualitySource,
  priceSource,
  locationSource,
}) => {
  const { setValue } = useFormContext();
  
  // ✅ Tambahkan useRef dan hook untuk Enter to Add Row
  const quantityRef = useRef(null);
  useEnterToAddRowAndFocus(quantityRef, undefined, 'input[name*="product_id"]');

  const onCodeChangeHandler = async (code) => {
    if (code.length !== 36) {
      setValue(quantitySource, "");
      setValue(locationSource, "");
      setValue(nameSource, "");
      setValue(qualitySource, "");
      setValue(priceSource, "");
    } else {
      // ✅ Auto-focus ke quantity input setelah product dipilih
      if (quantityRef.current) {
        setTimeout(() => {
          quantityRef.current?.focus?.();
        }, 100);
      }
    }
  };

  const exclude = {};
  const exclude_ids = [];
  const items = formData.mutation_repacking_items || [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].product_id) {
      exclude_ids.push(items[i].product_id);
    }
  }
  if (exclude_ids.length) {
    exclude["products.exclude_ids"] = exclude_ids;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        // "& .MuiGrid-item:not(:first-of-type)": { pt: 0 },
        "& .MuiGrid-item": { py: 0 },
        mt: 0,
      }}
    >
      <Grid item xs={12} lg={3}>
        <ProductInput
          fullWidth
          source={idSource}
          variant="outlined"
          validate={validateCode}
          label="mine.label.product_code"
          // optionValue="code"
          // optionText="code"
          onChange={onCodeChangeHandler}
          dependOn="date"
          reset={[
            quantitySource,
            locationSource,
            nameSource,
            qualitySource,
            priceSource,
          ]}
          detailType="all"
          defaultFilters={{ "products.active": 1 }}
          exclude={exclude}
          sx={{ display: "inline-flex" }}
          optionText={<OptionRendererProduct />}
          inputText={inputTextProduct}
          matchSuggestion={matchSuggestionProduct}
          helperText={false}
        />
        {/* <ReferenceInput
          source={idSource}
          reference="products"
          perPage={50}
          sort={{ field: "products.code", order: "ASC" }}
          filter={{ "products.active": 1 }}
          enableGetChoices={(filters) => !!filters["products.code"]}
        >
          <AutocompleteInput
            variant="outlined"
            label="mine.label.product_code"
            fullWidth
            validate={validateCode}
            optionText="code"
            // optionText={<ProductOptionRenderer />}
            // inputText={productInputText}
            // matchSuggestion={productMatchSuggestion}
            filterToQuery={productFilterToQuery}
            helperText={false}
          />
        </ReferenceInput> */}
      </Grid>

      <Grid item xs={12} lg={1}>
        <ReferenceInput
          source={locationSource}
          reference="warehouses"
          perPage={10}
          sort={{ field: "warehouses.created_at", order: "ASC" }}
          // filter={{ hasInstallments: true, "bad_debts.type": "2" }}
        >
          <AutocompleteInput
            variant="outlined"
            label="mine.label.warehouse"
            fullWidth
            validate={validateLocation}
            optionText="name"
            helperText={false}
            sx={{ "& .RaAutocompleteInput-textField": { minWidth: 0 } }}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} lg={1} ref={quantityRef}>
        <QuantityInput
          variant="outlined"
          source={quantitySource}
          label="mine.label.quantity"
          fullWidth
          validate={validateQuantity}
          quantity={quantity}
          formData={formData}
          helperText={false}
        />
      </Grid>

      <CodeDetailInput
        nameSource={nameSource}
        qualitySource={qualitySource}
        priceSource={priceSource}
        quantitySource={quantitySource}
        dependOn={idSource}
      />
    </Grid>
  );
};

const Inputs = ({
  formData, // The whole form data
  scopedFormData, // The data for this item of the ArrayInput
  getSource, // A function to get the valid source inside an ArrayInput
  ...rest
}) => {
  return (
    <CstInput
      {...scopedFormData}
      formData={formData}
      idSource={getSource("product_id")}
      quantitySource={getSource("quantity")}
      nameSource={getSource("name")}
      qualitySource={getSource("quality")}
      priceSource={getSource("price")}
      locationSource={getSource("warehouse_id")}
    />
  );
};
export default Inputs;